import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'anf-core-react';
import { TmntText } from '../Common/Text';

/**
 * ItemActions Component
 *
 * Renders item-related actions like cancel button when applicable.
 */
export default function ItemActions({
  orderProduct,
  text,
  onCancelItem,
}) {
  const {
    product,
    isCancellable,
  } = orderProduct;

  const {
    partNumber,
  } = product || {};

  // Get orderId from parent if available
  const orderId = orderProduct?.orderId || product?.orderId;

  // Handler for cancel button
  const handleCancelClick = () => {
    // Dispatch event to trigger legacy cancel modal
    const cancelEvent = new CustomEvent('cancel-item-modal:open', {
      detail: {
        orderId,
        itemId: partNumber,
        cancel: 'item',
      },
    });
    document.dispatchEvent(cancelEvent);

    // Call onCancelItem if provided
    if (onCancelItem) {
      onCancelItem({ partNumber, orderId });
    }
  };

  // If cancel button should not be shown, render nothing
  if (!isCancellable || !text?.cancelItem) {
    return null;
  }

  return (
    <Button
      variant="tertiary-dark"
      type="button"
      onClick={handleCancelClick}
      title={text.cancelItem}
      data-property="WSS_CANCEL_ITEM_CTA"
      data-cancel="item"
      data-orderitem={partNumber}
      data-order-id={orderId}
      isFullWidth
    >
      {typeof text.cancelItem === 'object' ? (
        <TmntText tmnt={text.cancelItem} />
      ) : (
        text.cancelItem
      )}
    </Button>
  );
}

ItemActions.propTypes = {
  orderProduct: PropTypes.shape({
    product: PropTypes.shape({
      partNumber: PropTypes.string,
      orderId: PropTypes.string,
    }).isRequired,
    isCancellable: PropTypes.bool,
    orderId: PropTypes.string,
  }).isRequired,
  text: PropTypes.shape({
    cancelItem: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
  onCancelItem: PropTypes.func,
};

ItemActions.defaultProps = {
  text: {},
  onCancelItem: undefined,
};
